"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var FormError_1 = __importDefault(require("../FormError"));
var FormLabel_1 = __importDefault(require("../FormLabel"));
require("./FormControl.scss");
var FormControlWrapper = function (props) {
    var _a = props.className, className = _a === void 0 ? '' : _a, children = props.children, errors = props.errors, _b = props.inline, inline = _b === void 0 ? false : _b, help = props.help, label = props.label, _c = props.expand, expand = _c === void 0 ? false : _c;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: classnames_1.default(className, {
                'flex items-center justify-between': inline,
            }) },
            react_1.default.createElement("div", { className: "flex-grow" },
                label && react_1.default.createElement(FormLabel_1.default, { label: label }),
                help && react_1.default.createElement("p", { className: "text-sm text-gray mb-0" }, help)),
            react_1.default.createElement("div", { className: classnames_1.default('flex flex-grow-0', {
                    'mt-0': inline,
                    'mt-2': !inline,
                    'pl-6': inline,
                }) },
                react_1.default.createElement("div", { className: classnames_1.default('form-control__field', {
                        'form-control__field-expand': expand,
                    }) }, children))),
        errors && react_1.default.createElement(FormError_1.default, { errors: errors })));
};
var FormControl = function (props) {
    var className = props.className, other = props.other, children = props.children, showOther = props.showOther, rest = __rest(props, ["className", "other", "children", "showOther"]);
    return (react_1.default.createElement("div", { "data-dusk": props.dusk, className: classnames_1.default('form-control', className, {
            'form-control--flush': props.flush,
        }) },
        react_1.default.createElement(FormControlWrapper, __assign({}, rest), children),
        other && showOther && react_1.default.createElement("div", { className: "form-control__other-wrapper" }, other)));
};
exports.default = FormControl;
//# sourceMappingURL=index.js.map